import React, { useState } from 'react';

import { Box, RadioList, RadioValue, Text } from '@bonanza-social/moonlight';
import { type Lang } from '../types';

type LanguageRadioSelectorProps = {
  lang: Lang;
  onSelect: (lang: Lang) => void;
  title?: string;
};

function LanguageRadioSelector({
  lang,
  onSelect,
  title,
}: LanguageRadioSelectorProps) {
  const [selectedLang, setSelectedLang] = useState<Lang>(lang);

  const handleSelect = (val: RadioValue) => {
    setSelectedLang(val as Lang);
    onSelect(val as Lang);
  };
  return (
    <Box
      gap="space-400"
      borderTopWidth="border-width-025"
      borderColor="borderSecondary"
      paddingTop="space-600"
    >
      {title && (
        <Text variant="body-m-semi" color="darkSurfacePrimary">
          {title}
        </Text>
      )}
      <Box flexDirection="row" alignItems="center" gap="space-400">
        <RadioList
          options={[{ label: 'Français', value: 'fr' }]}
          value={selectedLang}
          onValue={handleSelect}
        />
        <RadioList
          options={[{ label: 'English', value: 'en' }]}
          value={selectedLang}
          onValue={handleSelect}
        />
      </Box>
    </Box>
  );
}

export default LanguageRadioSelector;
